import {
  ProcessesApi,
  ProcessesApiGetCancelExchangePreviewRequest,
  ProcessesApiGetReturnSummaryRequest,
  ProcessesApiGetReviewsRequest
} from '@itsrever/rever-api'
import { apiClient } from '@/infrastructure/api'
import {
  toCancelExchangePreview,
  toPerformedReviews,
  toReturnProcess
} from './dto'

const processesApi = new ProcessesApi(undefined, undefined, apiClient)

async function getProcess(
  args: ProcessesApiGetReturnSummaryRequest,
  signal?: AbortSignal
) {
  const getProcessResponse = await processesApi.getReturnSummary(args, {
    signal
  })
  return toReturnProcess(getProcessResponse.data)
}

async function getReviews(
  args: ProcessesApiGetReviewsRequest,
  signal?: AbortSignal
) {
  const getReviewsResponse = await processesApi.getReviews(args, { signal })
  return toPerformedReviews(getReviewsResponse.data.item_reviews ?? [])
}

// Uploads the files straight to S3 and returns the links Zapier attaches to the ticket.
async function uploadIncidentDocuments(processId: string, files: File[]) {
  const response = await processesApi.createIncidentDocumentUploads({
    processId,
    pbCreateIncidentDocumentUploadsRequest: {
      documents: files.map((file) => ({
        content_type: file.type,
        size_bytes: String(file.size)
      }))
    }
  })
  const uploads = response.data.uploads ?? []
  await Promise.all(
    files.map(async (file, i) => {
      // Plain fetch: the presigned url must not get the API's credentials or auth header.
      const res = await fetch(uploads[i]?.upload_url ?? '', {
        method: 'PUT',
        headers: { 'Content-Type': file.type },
        body: file
      })
      if (!res.ok)
        throw new Error(`failed to upload ${file.name}: ${res.status}`)
    })
  )
  return uploads.map((upload) => upload.download_url ?? '')
}

async function getCancelExchangePreview(
  args: ProcessesApiGetCancelExchangePreviewRequest,
  signal?: AbortSignal
) {
  const response = await processesApi.getCancelExchangePreview(args, { signal })
  return toCancelExchangePreview(response.data)
}

export default {
  getProcess,
  getReviews,
  getCancelExchangePreview,
  uploadIncidentDocuments
}
